<div class="drag-grip"></div>
@if (hidden()) {
  <div class="hidden-indicator"></div>
}
<ng-content select="[matListItemAvatar],[matListItemIcon]"></ng-content>
<div class="mdc-list-item__content">
  @if (hidden() && hiddenLabel()) {
    <mulo-status-tag [description]="hiddenDescription()">{{ hiddenLabel() }}</mulo-status-tag>
  }
  <ng-content select="[matListItemTitle]"></ng-content>
  <ng-content select="[mat-line], [matLine], [matListItemLine]"></ng-content>
  <span #unscopedContent class="mat-mdc-list-item-unscoped-content" (cdkObserveContent)="updateItemLines(true)">
    <ng-content></ng-content>
  </span>
</div>

@for (action of visibleActions(); track $index) {
  @switch (action?.type) {
    @case ('toggle') {
      <mat-slide-toggle
        [checked]="action.data.checked"
        (change)="handleActionEvent(action, $event)"
        color="primary"
        [disabled]="action.disabled"
        class="is-slim is-quiet has-label-below"
      >
        @if (action.data.checked) {
          {{ (action.labels[0] | translate) || action.labels[0] }}
        } @else {
          {{ (action.labels[1] | translate) || action.labels[1] }}
        }
      </mat-slide-toggle>
    }
    @case ('visibility') {
      <mulo-visibility-switch
        [active]="action.data.visible"
        (changed)="handleActionEvent(action, $event)"
        [visibleLabel]="action.labels[0]"
        [hiddenLabel]="action.labels[1]"
        [toolTipText]="action.labels[2]"
        [disabled]="action.disabled"
      >
      </mulo-visibility-switch>
    }
    @case ('icon-btn') {
      <button
        mat-icon-button
        (click)="handleActionEvent(action, $event)"
        (muloMultipleEvents)="handleActionEvent(action, $event)"
        [attr.aria-label]="action.labels[1] || action.labels[0]"
        [disabled]="action.disabled"
        type="button"
      >
        <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
      </button>
    }
    @case ('button') {
      <button
        mat-button
        (click)="handleActionEvent(action, $event)"
        (muloMultipleEvents)="handleActionEvent(action, $event)"
        [disabled]="action.disabled"
        color="primary"
        type="button"
      >
        @if (action.icon) {
          <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
        }
        <span>{{ (action.labels[0] | translate) || action.labels[0] }}</span>
      </button>
    }
  }
}

@if (!_disabledSignal() && mainActionCount() > 0 && useMenu()) {
  <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [attr.aria-label]="moreBtnLabel()">
    <mat-icon svgIcon="dots-vertical"></mat-icon>
  </button>
  <mat-menu #actionsMenu="matMenu" xPosition="before">
    <ng-template matMenuContent>
      @for (action of menuActions(); track $index) {
        @switch (action?.type) {
          @case ('toggle') {
            <button
              mat-menu-item
              (click)="handleMenuToggle($event, toggleToggle, action)"
              [disabled]="action.disabled"
              type="button"
            >
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <mat-slide-toggle
                #toggleToggle
                [checked]="action.data.checked"
                color="primary"
                labelPosition="before"
                [disabled]="action.disabled"
              >
                @if (action.data.checked) {
                  {{ (action.labels[0] | translate) || action.labels[0] }}
                } @else {
                  {{ (action.labels[1] | translate) || action.labels[1] }}
                }
              </mat-slide-toggle>
            </button>
          }
          @case ('visibility') {
            <button
              mat-menu-item
              (click)="handleMenuToggle($event, visibilityToggle, action)"
              [disabled]="action.disabled"
              type="button"
            >
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <mat-slide-toggle
                #visibilityToggle
                [checked]="action.data.visible"
                color="primary"
                labelPosition="before"
                [disabled]="action.disabled"
              >
                @if (action.data.visible) {
                  {{ (action.labels[0] | translate) || action.labels[0] }}
                } @else {
                  {{ (action.labels[1] | translate) || action.labels[1] }}
                }
              </mat-slide-toggle>
            </button>
          }
          @case ('icon-btn') {
            <button
              mat-menu-item
              (click)="handleActionEvent(action, $event)"
              (muloMultipleEvents)="handleActionEvent(action, $event)"
              [disabled]="action.disabled"
              type="button"
            >
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <span>{{ (action.labels[0] | translate) || action.labels[0] }}</span>
            </button>
          }
          @case ('button') {
            <button
              mat-menu-item
              (click)="handleActionEvent(action, $event)"
              (muloMultipleEvents)="handleActionEvent(action, $event)"
              [disabled]="action.disabled"
              type="button"
            >
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <span>{{ (action.labels[0] | translate) || action.labels[0] }}</span>
            </button>
          }
        }
      }
    </ng-template>
  </mat-menu>
}
<ng-content select="[matListItemMeta]"></ng-content>

<ng-content select="mat-divider"></ng-content>

<!--
  Strong focus indicator element. MDC uses the `::before` pseudo element for the default
  focus/hover/selected state, so we need a separate element.
-->
<div class="mat-mdc-focus-indicator"></div>
